// TODO Should we map these to entities and properties of entities? Might be a bit easier to
// keep in sync with the data model and would allow us to just pass a entity/property name
// into the call to action component
export class CallToActionText {
    public static guidingPhilosophy = {
        purpose: "Your purpose answers the question of why this business exists. It should talk to your cause, your passion, what you care about.",
        vision: "Your vision is where you see the business heading, but to bring that vision to life you must paint a picture so that everyone is aligned and they can gain the traction to make it happen.",
        foundingStory: "The founding story is the story of how we got here and the influences that the founder brought with them.",
        bullseye: "The Bullseye answers the question 'What do we do?' But more importantly, it answers the question 'What don't we do'?",
    };
}
